document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".video-interview-video.iframe").forEach((section) => {
    const videoPreview = section.querySelector("video")
    const imagePreview = section.querySelector("img")
    const iframe = section.querySelector("iframe")

    if (videoPreview) {
      videoPreview.play().catch((error) => {
        console.log("Autoplay was prevented:", error)
      })
    }

    if (iframe && iframe.src) {
      if (!iframe.src.includes("enablejsapi")) {
        iframe.src += (iframe.src.includes("?") ? "&" : "?") + "enablejsapi=1"
      }
      if (!iframe.id) {
        iframe.id = "youtube-player-" + Math.random().toString(36).substr(2, 9)
      }
      iframe.setAttribute("src", iframe.src)
    }
  })

  let players = {}
  let lastState = {}
  let stateChangeTimeout = {}

  window.onYouTubePlayerAPIReady = function () {
    document.querySelectorAll(".video-interview-video.iframe iframe").forEach((iframe) => {
      const playerId = iframe.id
      players[playerId] = new YT.Player(playerId, {
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
        },
      })
    })
  }

  function onPlayerReady(event) {
    const player = event.target
    const section = document.getElementById(player.getIframe().id).closest(".video-interview-container")
    const videoInner = section.querySelector(".video-interview-inner")
    const playButton = section.querySelector(".youtube-button-open")
    const videoPreview = section.querySelector("video")
    const imagePreview = section.querySelector("img")

    playButton.addEventListener("click", function () {
      section.classList.add("opened")
      videoInner.classList.add("opened")
      if (videoPreview) videoPreview.style.display = "none"
      if (imagePreview) imagePreview.style.display = "none"

      if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
        player.loadVideoById(player.getVideoData().video_id)
        player.addEventListener("onReady", (event) => event.target.playVideo())
      } else {
        player.playVideo()
      }
    })
  }

  function onPlayerStateChange(event) {
    const playerId = event.target.getIframe().id
    const section = document.getElementById(playerId).closest(".video-interview-container")
    const videoInner = section.querySelector(".video-interview-inner")
    const videoPreview = section.querySelector("video")
    const imagePreview = section.querySelector("img")

    clearTimeout(stateChangeTimeout[playerId])
    stateChangeTimeout[playerId] = setTimeout(() => {
      if (event.data === lastState[playerId]) {
        handleStateChange(event, videoInner, videoPreview, imagePreview, section)
      }
    }, 200)
    lastState[playerId] = event.data
  }

  function handleStateChange(event, videoInner, videoPreview, imagePreview, section) {
    if (event.data === YT.PlayerState.PLAYING) {
      videoInner.classList.add("opened")
      section.classList.add("opened")
      if (videoPreview) videoPreview.style.display = "none"
      if (imagePreview) imagePreview.style.display = "none"
    } else if (event.data === YT.PlayerState.PAUSED) {
      videoInner.classList.remove("opened")
      section.classList.remove("opened")
      if (videoPreview) videoPreview.style.display = "block"
      if (imagePreview) imagePreview.style.display = "block"
    }
  }

  const tag = document.createElement("script")
  tag.src = "//www.youtube.com/player_api"
  document.getElementsByTagName("script")[0].parentNode.insertBefore(tag, null)
})
